import React, { createContext, useContext, useEffect, useState } from "react";

const LocationContext = createContext(null);
const KEY = "zyro_location";

// Known Zyro cities → coordinates for nearest-match
const CITIES = [
  { name: "Mumbai", lat: 19.076, lon: 72.877 },
  { name: "Delhi", lat: 28.704, lon: 77.102 },
  { name: "Bengaluru", lat: 12.972, lon: 77.594 },
  { name: "Hyderabad", lat: 17.385, lon: 78.487 },
  { name: "Jaipur", lat: 26.912, lon: 75.787 },
  { name: "Goa", lat: 15.299, lon: 74.124 },
  { name: "Kochi", lat: 9.931, lon: 76.267 },
  { name: "Udaipur", lat: 24.585, lon: 73.712 },
  { name: "Manali", lat: 32.239, lon: 77.189 },
];

function nearest(lat, lon) {
  let best = CITIES[0];
  let bestDist = Infinity;
  for (const c of CITIES) {
    const d = (lat - c.lat) ** 2 + (lon - c.lon) ** 2;
    if (d < bestDist) {
      bestDist = d;
      best = c;
    }
  }
  return best.name;
}

export function LocationProvider({ children }) {
  const [city, setCity] = useState(() => localStorage.getItem(KEY) || "Mumbai");
  const [detecting, setDetecting] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, city);
  }, [city]);

  const detect = () => {
    if (!navigator.geolocation) return;
    setDetecting(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const matched = nearest(pos.coords.latitude, pos.coords.longitude);
        setCity(matched);
        setDetecting(false);
      },
      () => setDetecting(false),
      { timeout: 8000 }
    );
  };

  return (
    <LocationContext.Provider value={{ city, setCity, detect, detecting, cities: CITIES.map((c) => c.name) }}>
      {children}
    </LocationContext.Provider>
  );
}

export const useLocation = () => useContext(LocationContext);
